import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const Wrapper = styled.div(
  ({ theme: { spacers, admanColors } }) => css<{ $isActive?: boolean }>`
    font-size: 14px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: ${spacers!.spacer03};
    color: ${admanColors!.gray.light.fg[2]};
    fill: ${admanColors!.gray.light.fg[2]};
    border-radius: ${spacers!.spacer02};
    cursor: pointer;

    &:hover {
      background-color: ${admanColors!.gray.light.bg3[4]};
    }

    ${({ $isActive }): FlattenSimpleInterpolation | string =>
      $isActive
        ? css`
            background-color: ${admanColors!.gray.light.bg3[0]};
            color: ${admanColors!.gray.light.fg[0]};
            fill: ${admanColors!.gray.light.fg[0]};

            &:hover {
              background-color: ${admanColors!.gray.light.bg3[2]};
            }
          `
        : ''}
  `
);

export const IconWrapper = styled.span`
  width: 24px;
  height: 24px;
  margin-right: ${({ theme }): string => theme.spacers!.spacer02};
  display: flex;
  align-items: center;

  & svg {
    height: 18px;
    width: 18px;
    fill: inherit;

    > * {
      fill: inherit;
    }
  }
`;
